export const restrictedDomains = [
    // Common personal email providers
    'gmail.com', 'yahoo.com', 'hotmail.com', 'outlook.com', 'aol.com',
    'icloud.com', 'protonmail.com', 'mail.com', 'zoho.com', 'yandex.com',
    'gmx.com', 'live.com', 'me.com', 'inbox.com',
    
    // Temporary/disposable email domains
    'yopmail.com', 'tempmail.com', 'temp-mail.org', 'guerrillamail.com',
    'mailinator.com', 'dispostable.com', '10minutemail.com', 'throwawaymail.com',
    'sharklasers.com', 'mintemail.com', 'trashmail.com', 'maildrop.cc',
    'getairmail.com', 'tempr.email', 'fakeinbox.com', 'tempinbox.com',
    'mailnesia.com', 'tempmailaddress.com', 'getnada.com', 'emailondeck.com',
    'mohmal.com', 'spamgourmet.com', 'mytemp.email', 'temp-mail.io',
    'tempmail.net', 'instantemailaddress.com', 'emailfake.com', 'burnermail.io',
    'temp-mail.ru', 'mailpoof.com', 'fakemail.net', 'trashmail.net',
    'mailforspam.com', 'tempail.com', 'disposable-email.com', 'tempmailer.com',
    'emailsendr.com', 'faketempmail.com', 'spambox.us', 'jetable.org',
    
    // // More common personal email providers
    // 'fastmail.com', 'mail.ru', 'tutanota.com', 'hey.com', 'gmx.net',
    // 'gmx.us', 'sina.com', 'qq.com', '163.com', '126.com',
    // 'yeah.net', 'foxmail.com', 'rediffmail.com', 'aim.com', 'comcast.net',
    // 'verizon.net', 'att.net', 'sbcglobal.net', 'cox.net', 'rocketmail.com',
    // 'bellsouth.net', 'charter.net', 'shaw.ca', 'ntlworld.com', 'btinternet.com',
    // 'earthlink.net', 'optonline.net', 'mindspring.com', 'frontiernet.net', 
    // 'laposte.net', 'web.de', 'libero.it', 'rambler.ru', '21cn.com'
  ]